import { ItemCreationFormValuesType } from '../../utils/helpers/convertFormToQueryInput';

export enum CreatePageStepsEnum {
  DealType = 'dealType',
  PropertyType = 'propertyType',
  OwnerType = 'ownerType',
  Form = 'form'
}

export interface CreateNewItemsProps {
  accessToken?: string;
  values: ItemCreationFormValuesType;
}
